import { render, staticRenderFns } from "./Charity.vue?vue&type=template&id=b95543da&scoped=true&"
import script from "./Charity.vue?vue&type=script&lang=js&"
export * from "./Charity.vue?vue&type=script&lang=js&"
import style0 from "./Charity.vue?vue&type=style&index=0&id=b95543da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95543da",
  null
  
)

export default component.exports